<template>
    <div>
        <div class="section-subtitle">
            <i class="icon icon-grid"></i><span>{{ $t("app.links.budget_requests") }}<budget-forms-list :curFormSelect="'/form01-123'"/></span>
            <forms-download-reprt
                :progress="progress"
                :isReportUploading="isReportUploading"
                :form="form"
                :guListLen="guListLen"
                :header="header"
                :isParentGuExist="isParentGuExist"
                :isHeadGu="isHeadGu"
                :hasDeltaRep="true"
                @checkSignatories="checkSignatories"
                @downloadRep="downloadRep"
                @downloadBatchReports="downloadBatchReports"
                @downloadBatchReportsPaid="downloadBatchReportsPaid"
                @downloadDeltaRep="downloadDeltaRep"
            ></forms-download-reprt>
        </div>
        <div class="filter-container">
            <div class="left-content">
            </div>
            <div class="right-content">
                <c-budget-forms-data-transfer
                        v-if="!isGkkpMode && !(progress < 100) && variantAttribute"
                        :header="header"
                        :lng="lng"
                        :getDataTransferText="getDataTransferText"
                        :getErrText="getErrText"
                        :makeToast="makeToast"
                        @reloadTable="loadDatas"
                    />
                <div class="filter-actions filter-actions-flex">
                    <c-budget-forms-copy-data
                        v-if="!(progress < 100) && variantAttribute && (header.year < header.cur_year + 2)"
                        :budgetForm="budgetForm"
                        :header="header"
                        :isLoad="isLoad"
                        @keyPress="keyPress"
                    />
                    <b-button :style="{ 'minWidth': '110px' }" variant="success" @click="prepareForSave" :disabled="isLoad || !variantAttribute || !hasChangedFields">{{ getCommonText('save') }}</b-button>
                </div>
            </div>
        </div>
        <b-overlay :show="isLoad" rounded="sm">
            <div class="table-container">
                <b-overlay :show="mainTableOverlay" rounded="sm">
                <b-table
                    :fields="tableFields"
                    :items="budgetForm"
                    responsive="true"
                    bordered
                    head-variant="light"
                    sticky-header="true"
                    no-border-collapse
                >
                    <template #top-row="data">
                        <td class="td-numbering"></td>
                        <td class="td-numbering table-success text-center">1</td>
                        <td class="td-numbering table-danger text-center">2</td>
                        <td class="td-numbering table-warning text-center">3</td>
                        <td class="td-numbering"></td>
                    </template>
                    <template #head(action)>
                        <div class="text-center">
                            <b-form-checkbox
                                v-model="selectAll"
                                @change="e => setIsAllDelete(e)"
                                :value="true"
                                :unchecked-value="false" />
                        </div>
                    </template>
                    <template #head(more)>
                        <div class="text-center">
                            <i
                                :title="getCommonText('del_selected')"
                                class="icon icon-close table-all-remove"
                                @click="deleteItemWithAttachedFiles(`${selectAll ? getDecText('del_all_recs') : getDecText('del_selected_recs')}`)"/>
                        </div>
                    </template>
                    <template #cell(action)="data">
                        <b-form-checkbox
                            v-if="data.item.is_row_editable"
                            class="text-center"
                            v-model="data.item.itemToDelete"
                            @input="e => { if (!e) selectAll = false; }"
                            :value="true"
                            :unchecked-value="false" />
                    </template>
                    <template #cell(name)="data">
                        <div
                            class="bp-category-name"
                            :style="`padding-left: ${data.item.level}rem`"
                        >
                            <div>{{ data.item['name_' + lng] }} </div>
                        </div>
                    </template>
                    <template #cell(summa)="data">
                        <div v-if="!data.item.article_subsidy"></div>
                        <div
                            v-else-if="data.item.article_subsidy === '300' || data.item.article_subsidy && budgetForm.some(itm => data.item.article_subsidy === itm.parent_code)"
                            class="text-right"
                        >{{ $n(getParentSumm(data.item.article_subsidy)) }}</div>
                        <div v-else-if="variantAttribute">
                            <b-form-input
                                        class="text-right"
                                        v-model="data.item.summa"
                                        :disabled="nameIsEmpty(data.item, ['name_ru', 'name_kk'])"
                                        @keyup.enter.exact="keyup13"
                                        @keypress="keyPress($event, '^\\d*\\.?\\d{0,9}$')"
                                        @blur="inputFixed(data.item, 'summa', data.item.summa, 2, 0)"
                                        @input="markAsChanged(data.item)">
                            </b-form-input>
                            <div class="error" style="position: relative; top: -25px;">
                                <template v-if="(data.item.article_subsidy === '100' && getParentSumm('300') < 0)">
                                    <i class="icon icon-danger"></i>
                                    <div class="pop-up">
                                        <p class="red-text">{{ getCommonText("not_valid") }}</p>
                                        <p>{{ getCommonText("costs_more_incomes") }}</p>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div v-else class="text-right">{{ $n(data.item.summa) }}</div>
                    </template>
                    <template #cell(files)="data">
                        <div class="text-center">
                            <span
                                v-if="data.item.is_row_editable"
                                class="blue pointer underline"
                                @click="onFilesClick(data.item)"
                            >({{data.item.files}})</span>
                        </div>
                    </template>
                    <template #cell(more)="data">
                        <div class="text-center">
                            <i 
                                :title="getCommonText('del_rec')" 
                                class="icon icon-clear table-remove" 
                                v-if="variantAttribute && data.item.is_row_editable" 
                                @click="deleteItemWithAttachedFiles(`${getCommonText('del_rec')}?`, data.item, data.index)"
                            ></i>
                        </div>
                    </template>
                    <template #bottom-row="data">
                        <td class="text-right" colspan="2">{{ getCommonText('total') }}</td>
                        <td class="text-right">{{ $n(total) }}</td>
                        <td colspan="3"></td>
                    </template>
                </b-table>
                </b-overlay>
            </div>
        </b-overlay>
        <files-updown v-if="isFilterReady" 
                      :header="header"
                      :variant-attribute="variantAttribute"
                      :variant-name="variantName ? variantName['pure_name_' + lng] : ''"
                      :load="load"
                      @getFiles="getFiles"
                      @getNewFiles="getNewFiles($event)"
                      @delFile="delFile($event)"
                      @onFilePreview="onFilePreview"
                      ref="fileUpdown"
        ></files-updown>
        <modal-files-management-nodecode
            ref="modalFilesManagement"
            :variant-attribute="variantAttribute"
            @triggDownloadFile="triggDownloadFile"
            @triggDownloadAllFiles="triggDownloadAllFiles"
            @fileUpload="fileUpload"
            @toggleIsAdd="toggleIsAdd($event)"
        />
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import FilesUpdown from '@/modules/budget-request/FilesUpdown';
import BudgetFormsList from '@/modules/budget-request/components/budget-forms-list.vue';
import ModalFilesManagementNodecode from '@/modules/budget-request/components/modal-files-management-nodecode.vue';
import FormsHandlerMixin1 from "../mixins/forms-handler-mixin-1";
import CBudgetFormsCopyData from '@/modules/budget-request/components/budget-forms-copy-data.vue';
import FormsDownloadReprt from "@/modules/budget-request/components/forms-download-reprt.vue";
import CBudgetFormsDataTransfer from '@/modules/budget-request/components/budget-forms-data-transfer.vue';

export default {
    name: 'Form312',
    components: { 
        FilesUpdown, 
        BudgetFormsList, 
        FormsDownloadReprt, 
        ModalFilesManagementNodecode, 
        CBudgetFormsCopyData,
        CBudgetFormsDataTransfer
    },
    mixins: [FormsHandlerMixin1],
    data() {
        return {
            form: {
                code: '312',
                name_ru: 'Расчет расходов на субсидии юридическим лицам, не являющимися государственными предприятиями',
                name_kk: 'Мемлекеттік кәсіпорындар болып табылмайтын заңды тұлғаларға субсидияларға арналған шығыстарды есептеу',
                spf: {
                    name: '312-Субсидии юридическим лицам',
                    spf: '312'
                }
            },
            dataTypeFilter: null,
            variantAttribute: null,
            variantName: null,
            budgetForm: [],
            header: null,
            files: null,
            load: false,
            openDisabled: false,
            isLoad: false,
            row_files: [],
            isAdd: false,
            rowId: false,
            newRowStartId: -1,
            categoryFieldNames: {ru: "name_ru", kk: "name_kk"},
        };
    },
    created() {
        this.$emit("setForm", this.form);
    },
    async mounted() {
        this.progress = 15;
    },
    watch: {
        openDisabled() {
            this.$emit("setOpenDisabled", this.openDisabled);
        },
        progress() {
            this.$emit("setProgress", this.progress);
        }
    },
    methods: {
        isFieldValid(value) {
            return value !== null && value !== '' && value > 0;
        },

        markAsChanged(item) {
            this.$set(item, 'isChanged', true);
        },

        getFiles(data) {
            this.files = data;
        },

        async loadDatas() {
            this.load = true;
            this.$set(this.header, 'form_version', '312')
            this.budgetForm.splice(0);
            try {
                const response = await fetch('/api-py/get-budget-request-form-with-row-attach-files/' + JSON.stringify(this.header));
                if (response.ok) {
                    const values = await response.json();
                    const defaultRowFiles = await this.getRawFiles();
                    this.dict.forEach((dictItem, i) => {
                        const val = values.find(v => dictItem.code && v.article_subsidy === dictItem.code);
                        const item = {
                            id: val ? val.id : i * (-1),
                            name_ru: dictItem.name_ru,
                            name_kk: dictItem.name_kk,
                            article_subsidy: dictItem.code,
                            parent_code: dictItem.parent_code,
                            level: dictItem.level,
                            summa: val ? val.summa : 0,
                            is_row_editable: this.isRowEditable(dictItem),
                            files: val ? val.files : 0,
                            row_files: val ? val.row_files : defaultRowFiles,
                            itemToDelete: false,
                            isChanged: false
                        };
                        this.budgetForm.push(item);
                    });
                }
                
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} loadDatas`, error.toString());
            }
            this.load = false;
        },

        async getRawFiles() {
            let emptyRowFiles = [];
            try {
                const response = await fetch(`/api-py/get-new-row-files-form/-1/${JSON.stringify(this.header)}`);
                if (response.ok) {
                    emptyRowFiles = await response.json();
                }
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} itemUpdate`, error.toString());
            }

            return emptyRowFiles;
        },

        toggleIsAdd(return_object) {
            const curBudgetForm = this.budgetForm.find(b => b.id === this.rowId)
            curBudgetForm['row_files'] = return_object['row_files']
            curBudgetForm['files'] = return_object['num_attach_files']
            this.isAdd = return_object['isAdd'];
            this.markAsChanged(curBudgetForm);
        },

        prepareForSave() {
            const values = [];
            if (this.getParentSumm('300') < 0) {
                this.makeToast('danger', this.getErrText('saving_error'), this.getErrText('bad_data_1'));
                return;
            }

            for (const row of this.budgetForm) {
                if (!row.is_row_editable) continue;
                if (!row.isChanged) continue;
                if (row.id <= 0 && !row.summa) continue;
                const item = {};
                this.$set(item, 'id', row.id);
                this.$set(item, 'article_subsidy', row.article_subsidy);
                this.$set(item, 'summa', this.safeDecimal(row.summa).toNumber());
                this.$set(item, 'row_files', row.row_files);

                values.push(item);
            }

            if (values.length > 0) {
                this.$bvModal.msgBoxConfirm(
                    this.getCommonText('on_save'),
                    {
                        title: this.getCommonText('confirm'),
                        size: 'lg',
                        buttonSize: 'sm',
                        okVariant: 'success',
                        okTitle: this.getCommonText('yes'),
                        cancelTitle: this.getCommonText('cancel'),
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    })
                    .then(value => {
                        if (value && this.variantAttribute) {
                            this.save(values);
                        }
                    })
                    .catch(error => {
                        this.makeToast('danger', this.getErrText('saving_error'), error.toString());
                    });
            } else {
                this.makeToast('warning', this.getErrText('warning'), this.getErrText('not_saved'));
                this.loadDatas();
            }
        },

        async save(values, isDeleting = false) {
            this.isLoad = true;
            try {
                const data = {
                    values: values,
                    header: this.header,
                    total: this.total,
                };
                const response = await fetch("/api-py/save-brform312/", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json;charset=utf-8",
                    },
                    body: JSON.stringify(data),
                });
                const result = await response.json();
                if ((response.status === 200) && (result.result === 'success')) {
                    this.loadDatas();
                    
                    if (this.files.length === 0 && !isDeleting) {
                        this.makeToast('warning', this.getErrText('warning'), this.getErrText('no_docs'));
                    }
                    this.makeToast('success', this.getErrText('msg'), this.getErrText('saved'));
                    this.deletingAgreementTotalResultHandler(result);
                } else {
                    throw this.getErrText('bad_data');
                }
            } catch (e) {
                this.makeToast('danger', this.getErrText('warning'), e.toString());
            } finally {
                this.isLoad = false;
            }
        },

        async loadSpecificData() {
            await this.loadDict();
        },

        async loadDict() {
            const varStartDate = this.header.variant_date_time;
            const varEndDate = this.header.variant_end_date;
            const firstDayOfYear = this.header.first_date_of_year_gu

            const url = `/api-py/dict-article-subsidy/${varStartDate}/${varEndDate}/${firstDayOfYear}/`;
            try {
                const response = await fetch(url);
                if (response.ok) {
                    this.dict = await response.json();
                } else {
                    this.makeToast('danger', `${this.getErrText('bad_request')} loadDict()`, `HTTP ${response.status}: ${response.statusText}`);
                }
            } catch (error) {
                this.dict = [];
                this.makeToast('danger', `${this.getErrText('bad_request')} loadDict()`, error.toString());
            }
        },

        getParentSumm(code, budgetForm = this.budgetForm) {
            let total = this.safeDecimal(0);
            if (code === '300') {
                let incomes = this.safeDecimal(0);
                const incomesItem = budgetForm.find(item => item.article_subsidy === '100');
                if (incomesItem) {
                    incomes = this.safeDecimal(incomesItem.summa);
                }
                const costs = budgetForm.reduce((acc, item) => {
                    if ((item.article_subsidy === '100' || !item.hasOwnProperty('summa'))) return acc;
                    const summa = this.safeDecimal(item.summa);
                    return acc.add(summa);
                }, this.safeDecimal(0));
                total = costs.minus(incomes);
            } else {
                for (const row of budgetForm) {
                    if (row.parent_code && row.parent_code.startsWith(code)) {
                        const summa = this.safeDecimal(row.summa);
                        total = total.add(summa);
                    }
                }
            }
            return total.toNumber();
        },

        isRowEditable(item) {
            return item.code && item.code !== '300' && !this.dict.some(itm => item.code === itm.parent_code);

        },

        ifDeletingForbidden(row) {
            const budgetFormCopy = JSON.parse(JSON.stringify(this.budgetForm));
            let incomes = this.safeDecimal(0);
            let costs = this.safeDecimal(0);

            budgetFormCopy.forEach(item => {
                if (item.itemToDelete) {
                    this.$set(item, 'summa', 0);
                }
                if (row && item.id === row.id) {
                    this.$set(item, 'summa', 0);
                }

                if (item.article_subsidy === '100') {
                    incomes = incomes.add(this.safeDecimal(item.summa));
                } else (
                    costs = costs.add(this.safeDecimal(item.summa))
                )
            });

            if (incomes.greaterThan(costs)) {
                this.makeToast('danger', 
                                this.getErrText('deleting_impossible'), 
                                this.getErrText('check_sums', {
                                    incomes: incomes.toNumber(), 
                                    costs: costs.toNumber()
                                }));
                this.budgetForm.forEach(item => {
                    this.$set(item, 'itemToDelete', false);
                });
                return true;
            }

            return false;
        },

        getRowsToDelItem(item, condition) {
            if (condition) {
                this.$set(item, 'summa', 0);
                if (item.id > 0) {
                    this.$set(item, 'isChanged', true);
                    return item;
                } else {
                    this.$set(item, 'isChanged', false);
                }
            } else {
                if (item.isChanged) {
                    return item;
                }
            }
            return null;
        },

        deleteItemWithAttachedFiles(msg, row = false, index = false) {
            if (!this.variantAttribute || this.isLoad 
                || (!row && !this.budgetForm.some(itm => itm.itemToDelete))) return;
            if (this.ifDeletingForbidden(row)) {
                return;
            }
            this.$bvModal.msgBoxConfirm(
                msg,
                {
                    title: this.getCommonText('confirm'),
                    size: 'lg',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: this.getCommonText('yes'),
                    cancelTitle: this.getCommonText('cancel'),
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    if (value) {
                        const rowsToDel = [];
                        if (row) {
                            this.budgetForm.forEach(item => {
                                const rowsToDelItem = this.getRowsToDelItem(item, item.id === row.id)
                                if (rowsToDelItem) {
                                    rowsToDel.push(rowsToDelItem);
                                }
                            });
                        } else {
                            this.budgetForm.forEach(item => {
                                const rowsToDelItem = this.getRowsToDelItem(item, item.itemToDelete)
                                if (rowsToDelItem) {
                                    rowsToDel.push(rowsToDelItem);
                                }
                            });
                        }
                         if (rowsToDel.length) {
                                this.save(rowsToDel, true);
                                this.selectAll = false;
                            }
                    }
                })
                .catch(error => {
                    this.makeToast('danger', this.getErrText('on_del'), error.toString());
                });
        },
    },
    computed: {
        total() {
            const summa = this.getParentSumm('300');
            return Math.ceil(summa);
        },

        getFormText() {
            return this.setFormText('forms_v2_common.');
        },

        hasChangedFields() {
            const isChanged = this.budgetForm.find(itm => itm.isChanged);
            return !!isChanged;
        },

        tableFields() {
            if (this.$i18n.locale) {
                return [
                    {
                        key: 'action',
                        label: ' '
                    },
                    {
                        key: 'name',
                        label: this.getCommonText('name'),
                        thStyle: { width: '37rem' },
                        tdStyle: { width: '37rem' }
                    },
                    {
                        key: 'summa',
                        label: this.getFormText('summa')
                    },
                    {
                        key: 'files',
                        label: this.getCommonText('files')
                    },
                    {
                        key: 'more',
                        label: ''
                    }
                ];
            };
            return [];
        },
    }
};
</script>
<style scoped>
    .goods-form-val-msg {
        font-size: 0.5rem;
        font-style: italic;
        color: red;
    }
    .filter-actions-flex {
        display: flex;
    }
    .bp-category-name {
        width: 100%;
    }
    .bf-disabled {
        pointer-events: none;
        opacity: 0.5;
        cursor: not-allowed;
    }
</style>